import { useState } from "react";

const faqs = [
  {
    q: "日漫情报站多久更新一次最新话？",
    a: "我们会在各大连载作品官方发布更新后的第一时间同步内容，通常每天都会有多部人气作品的最新话情报与解读上线，确保你不错过任何一话。",
  },
  {
    q: "剧透专区的内容会损坏我的追更体验吗？",
    a: "情报剧透专区的内容均带有明确的「剧透预警」提示，并默认折叠。如果你不希望被提前剧透，可以跳过该分类，仅浏览最新话与连载更新版块。",
  },
  {
    q: "休刊提醒是怎么来的？",
    a: "休刊公告分类会汇总各大作品官方发布的休刊与复刊安排，并标注预计的恢复连载时间，帮助你合理安排追更节奏。",
  },
  {
    q: "网站内容是否尊重原作版权？",
    a: "本站仅提供资讯汇总、剧情解读与更新提醒服务，所有内容均注明出处并尊重原作版权。如需阅读正版内容，建议前往官方授权的正版渠道。",
  },
  {
    q: "如何订阅最新的日漫更新资讯？",
    a: "你可以通过「关于我们」页面的联系方式订阅我们的资讯快报，或收藏本站并关注各分类页面，第一时间获取最新的日漫更新动态。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-4xl px-4 py-14 md:px-6" aria-labelledby="faq-heading">
      <div className="text-center">
        <h2 id="faq-heading" className="font-heading text-2xl text-foreground-950 md:text-3xl">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-600">关于追更与使用本站的常见疑问解答。</p>
      </div>

      <div className="mt-8 space-y-3">
        {faqs.map((faq, index) => {
          const open = openIndex === index;
          return (
            <div key={index} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                aria-expanded={open}
              >
                <span className="text-sm font-semibold text-foreground-950 md:text-base">{faq.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                    open ? "rotate-180" : ""
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg" />
                </span>
              </button>
              {open && <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">{faq.a}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}